module.exports = __webpack_public_path__ + "img/zone250400.4f80222d.png";